// Клієнтські налаштування (localStorage) — без сервера, працюють і офлайн.

export type ExplStyle = 'instructor' | 'casual';

const KEY = 'explStyle';

/** Стиль пояснень до питань: «інструктор» (за замовч.) або «дружбан». */
export function getExplStyle(): ExplStyle {
  try {
    return localStorage.getItem(KEY) === 'casual' ? 'casual' : 'instructor';
  } catch {
    return 'instructor';
  }
}

export function setExplStyle(s: ExplStyle): void {
  try {
    localStorage.setItem(KEY, s);
  } catch {
    /* ignore */
  }
}
